import { useTranslation } from 'react-i18next';
import { UserStatus } from '../../../services/api';
import { ShieldIcon, CheckIcon, CloseIcon } from './Icons';

export default function PersonalDataCard({ userStatus }: { userStatus: UserStatus }) {
    const { t } = useTranslation();
    return (
        <div className="privacy-card">
            <div className="card-header">
                <div className="header-icon shield">
                    <ShieldIcon size={20} />
                </div>
                <h3>{t('privacy.personal_data_overview')}</h3>
            </div>
            <p className="card-subtitle">{t('privacy.store_necessary')}</p>

            <div className="data-checklists">
                <div className="checklist-group">
                    <div className="group-title">{t('privacy.we_store')}</div>
                    <ul className="checklist">
                        <li><CheckIcon /> <span>{t('privacy.email_address')}</span></li>
                        <li><CheckIcon /> <span>{t('privacy.auth_profile', { status: userStatus.isAuthenticated ? t('privacy.verified') : t('privacy.guest') })}</span></li>
                        <li><CheckIcon /> <span>{t('privacy.subscription_status')}</span></li>
                        <li><CheckIcon /> <span>{t('privacy.trip_ai_history')}</span></li>
                    </ul>
                </div>

                <div className="checklist-group">
                    <div className="group-title">{t('privacy.we_do_not_store')}</div>
                    <ul className="checklist no-items">
                        <li><CloseIcon /> <span>{t('privacy.phone_number')}</span></li>
                        <li><CloseIcon /> <span>{t('privacy.physical_address')}</span></li>
                        <li><CloseIcon /> <span>{t('privacy.raw_payment_data')}</span></li>
                    </ul>
                </div>
            </div>
        </div>
    );
}
